module.exports = {"371373100":"坪上镇","371373101":"团林镇","371373102":"壮岗镇","371373103":"朱芦镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371373.json
// module id = 1471
// module chunks = 0